import { GET_MODIFIER_LIST , CREATE_MODIFIER , UPDATE_MODIFIER, DELETE_MODIFIER} from './modifierTypes'
import { URL_GET_MODIFIER_LIST , URL_CREATE_MODIFIER , URL_UPDATE_MODIFIER,  URL_DELETE_MODIFIER} from './modifierUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
import axios from "../../axios";

export default {
    [GET_MODIFIER_LIST]({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.get(URL_GET_MODIFIER_LIST, { params: item })
                .then((response) => {
                    let responseModel = new ResponseModel(response);
                    if (responseModel.status == STATUS_OK) {
                        let resultModel = responseModel.result;
                        if (resultModel.status == STATUS_OK) {
                            let data = resultModel.data;
                            commit(GET_MODIFIER_LIST, data)
                            resolve(data);
                        } else {
                            commit(GET_MODIFIER_LIST, { items: [], _links: {}, _meta: {} });
                            resolve({ items: [], _links: {}, _meta: {} });
                        }
                    } else {
                        commit(GET_MODIFIER_LIST, { items: [], _links: {}, _meta: {} });
                        resolve({ items: [], _links: {}, _meta: {} });
                    }
                })
                .catch((error) => { reject(error); })
        })
    },
    [CREATE_MODIFIER] ({dispatch} ,item) {
      return new Promise((resolve , reject) => {
        axios.post(`${URL_CREATE_MODIFIER}` , item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
            if(responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if(resultModel.status == STATUS_OK) {
                let data = resultModel.data;
                dispatch(GET_MODIFIER_LIST, item);
                resolve(data);
              } else {
                reject(resultModel.message);
              }
            } else {
              reject(responseModel.message);
            }
        })
        .catch((error) => { reject(error)})
      })
    },

    [UPDATE_MODIFIER] ({dispatch} ,item) {
      return new Promise((resolve , reject) => {
        axios.post(`${URL_UPDATE_MODIFIER}` , item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
            if(responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if(resultModel.status == STATUS_OK) {
                let data = resultModel.data;
                dispatch(GET_MODIFIER_LIST, item);
                resolve(data);
              } else {
                reject(resultModel.message);
              }
            } else {
              reject(responseModel.message);
            }
        })
        .catch((error) => { reject(error)})
      })
    },

    [DELETE_MODIFIER] ({dispatch} ,item) {
      return new Promise((resolve , reject) => {
        axios.post(`${URL_DELETE_MODIFIER}` , item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
            if(responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if(resultModel.status == STATUS_OK) {
                let data = resultModel.data;
                dispatch(GET_MODIFIER_LIST, item);
                resolve(data);
              } else {
                reject(resultModel.message);
              }
            } else {
              reject(responseModel.message);
            }
        })
        .catch((error) => { reject(error)})
      })
    },
}
